"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends4 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _qs = _interopRequireDefault(require("qs"));
var _base = _interopRequireDefault(require("./base"));
var _models = require("../models");
var _consts = require("../utils/consts");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * `Service` The Documents service, is target to fetch documents data.
 */
var Documents = /*#__PURE__*/function (_Base) {
  /**
   * Create the Documents service instance.
   *
   * @param sdk - the SDK instance
   */
  function Documents(sdk) {
    var _this;
    (0, _classCallCheck2["default"])(this, Documents);
    _this = _callSuper(this, Documents, [sdk]);
    _this.versionsCancelTokenMap = new Map();
    _this.documentsCancelTokenMap = new Map();
    return _this;
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  (0, _inherits2["default"])(Documents, _Base);
  return (0, _createClass2["default"])(Documents, [{
    key: "getDocuments",
    value: (
    /**
     * Get folder documents.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/branches/master/5017d9cb6f4e3-shared-list-documents-from-a-folder
     *
     * @param projectId - is the project id
     * @param folderUrn - is the folder urn
     * @param options - is to support pagination parameters
     *                          \{
     *                             limit: 10
     *                             offset: 0,
     *                             sortCriteria: [\{ name: string, acs: boolean, isCustomAttribute: boolean \}],
     *                             filterCriteria: [\{ name: string, value: string \}],
     *                             includeExtendedPropertiesInNamespaces: string
     *                          \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns filter result. With the shape of \{
     *                   documents:[], // Array of documents
     *                   pagination: \{
     *                     limit: integer,
     *                     offset: integer,
     *                     nextUrl: string or null,
     *                     totalResults: integer,
     *                     hasNext: boolean
     *                   \}
     *               \}
     */
    function () {
      var _getDocuments = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(projectId, folderUrn, options, config) {
        var _this2 = this;
        var conf, url, response, _response$data, _response$data$result, results, _response$data$pagina, pagination;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Setup cancel token based on folder urn.
              conf = (0, _extends4["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, (config === null || config === void 0 ? void 0 : config.cancelByFolder) === false ? {
                getter: function getter() {
                  return _this2.documentsCancelToken;
                },
                setter: function setter(token) {
                  return _this2.documentsCancelToken = token;
                },
                clearer: function clearer() {
                  return _this2.documentsCancelToken = undefined;
                }
              } : {
                getter: function getter() {
                  return _this2.documentsCancelTokenMap.get(folderUrn);
                },
                setter: function setter(token) {
                  return _this2.documentsCancelTokenMap.set(folderUrn, token);
                },
                clearer: function clearer() {
                  return _this2.documentsCancelTokenMap["delete"](folderUrn);
                }
              }), config);
              url = "/projects/".concat(projectId, "/folders/").concat(folderUrn, "/documents:query");
              _context.next = 4;
              return this.HttpService.dmV3.post(url, options, conf);
            case 4:
              response = _context.sent;
              _response$data = response.data, _response$data$result = _response$data.results, results = _response$data$result === void 0 ? [] : _response$data$result, _response$data$pagina = _response$data.pagination, pagination = _response$data$pagina === void 0 ? {} : _response$data$pagina;
              return _context.abrupt("return", {
                documents: results.map(_models.EntityItem.parseV3),
                pagination: (0, _extends4["default"])({}, pagination, {
                  hasNext: !!pagination.nextUrl
                })
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getDocuments(_x, _x2, _x3, _x4) {
        return _getDocuments.apply(this, arguments);
      }
      return getDocuments;
    }()
    /**
     * Get permissions on a specific document for the current user
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F3.0/ACC-Folder-Permission.oas2.yml?view=%2Fpermissions%2Fgetuserdocumentpermissions
     *
     * @param projectId -  is the project id
     * @param documentUrn - is the document urn
     * @param config - Configurable object for overwrite request parameters.
     * @returns permissions, with the shape of
     *                    autodeskId: string,
     *                    subjectId: string,
     *                    actions: [string],
     */
    )
  }, {
    key: "getPermissions",
    value: (function () {
      var _getPermissions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(projectId, documentUrn, config) {
        var url, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              url = "/projects/".concat(projectId, "/documents/").concat(documentUrn, "/permissions");
              _context2.next = 3;
              return this.HttpService.dmV3.get(url, config);
            case 3:
              response = _context2.sent;
              return _context2.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getPermissions(_x5, _x6, _x7) {
        return _getPermissions.apply(this, arguments);
      }
      return getPermissions;
    }()
    /**
     * Get versions for a specific document
     * https://platform.stoplight.autodesk.com/docs/docs-cp/f015b593e2689-shared-list-versions-of-target-document
     *
     * @param projectId -  is the project id
     * @param folderUrn -is the folder urn
     * @param documentUrn - is the document urn
     * @param options - is to support query parameters
     *                             limit: 200
     *                             offset: 0,
     *                             includeExtendedPropertiesInNamespaces: 'n1,n2,n3',
     *                             includeTrashed: false
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that can resolve to a document's version. If the pagination parameter `options`
     *                   is passed, it supports paging the versions.
     */
    )
  }, {
    key: "getVersions",
    value: (function () {
      var _getVersions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(projectId, folderUrn, documentUrn, options, config) {
        var _this3 = this;
        var conf, query, url, _yield$this$HttpServi, _yield$this$HttpServi2, results, _yield$this$HttpServi3, pagination;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // Setup cancel token based on folder urn.
              conf = (0, _extends4["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this3.versionsCancelTokenMap.get(folderUrn);
                },
                setter: function setter(token) {
                  return _this3.versionsCancelTokenMap.set(folderUrn, token);
                },
                clearer: function clearer() {
                  return _this3.versionsCancelTokenMap["delete"](folderUrn);
                }
              }), config);
              query = _qs["default"].stringify(options, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/documents/").concat(documentUrn, "/versions").concat(query);
              _context3.next = 5;
              return this.HttpService.dmV3.get(url, conf);
            case 5:
              _yield$this$HttpServi = _context3.sent;
              _yield$this$HttpServi2 = _yield$this$HttpServi.data;
              results = _yield$this$HttpServi2.results;
              _yield$this$HttpServi3 = _yield$this$HttpServi2.pagination;
              pagination = _yield$this$HttpServi3 === void 0 ? {} : _yield$this$HttpServi3;
              if (!results) {
                _context3.next = 12;
                break;
              }
              return _context3.abrupt("return", {
                versions: results.map(_models.EntityVersionItem.parseV3),
                hasNext: !!pagination.nextUrl
              });
            case 12:
              return _context3.abrupt("return", null);
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getVersions(_x8, _x9, _x10, _x11, _x12) {
        return _getVersions.apply(this, arguments);
      }
      return getVersions;
    }()
    /**
     * Delete documents in batch
     * https://platform.stoplight.autodesk.com/docs/docs-cp/1ffc2e4795c93-shared-batch-delete-documents
     *
     * @param projectId - is the project id
     * @param payload - include the array of document urns, ["urn:adsk.wipprod:dm.lineage:M7KsPcpXTn6nPPRhrQnjGA"]
     * @param config - Configurable object for overwrite request parameters.
     */
    )
  }, {
    key: "deleteDocuments",
    value: (function () {
      var _deleteDocuments = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(projectId, payload, config) {
        var response;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/documents:delete"), payload, config);
            case 2:
              response = _context4.sent;
              return _context4.abrupt("return", {
                success: (response.data.results || []).map(_models.EntityItem.parseV3),
                fail: response.data.errors || []
              });
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function deleteDocuments(_x13, _x14, _x15) {
        return _deleteDocuments.apply(this, arguments);
      }
      return deleteDocuments;
    }()
    /**
     * Restore documents in batch
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F1.1/Documents%20operation%20APIs.oas2.yml?view=%2Fbatch-operation%2Frestoredocuments
     *
     * @param projectId - is the project id
     * @param payload - include the array of document urns, ["urn:adsk.wipprod:dm.lineage:M7KsPcpXTn6nPPRhrQnjGA"]
     * @param config -  configurable object for overwrite request parameters.
     */
    )
  }, {
    key: "restoreDocuments",
    value: (function () {
      var _restoreDocuments = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(projectId, payload, config) {
        var response;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/documents:restore"), payload, config);
            case 2:
              response = _context5.sent;
              return _context5.abrupt("return", {
                success: (response.data.results || []).map(_models.EntityItem.parseV3),
                fail: response.data.errors || []
              });
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function restoreDocuments(_x16, _x17, _x18) {
        return _restoreDocuments.apply(this, arguments);
      }
      return restoreDocuments;
    }()
    /**
     * Update document
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F1.1/Documents%20operation%20APIs.oas2.yml?view=%2Fsingle-operation%2Frenamedocuments
     *
     * @param projectId - is the project id
     * @param payload -, include `versionedUrn`, `name`, `description`, name and description are optional
     *                            versionedUrn: "urn:adsk.wipqa:fs.file:vf.dIifAjZvTnenZsYRBCO94Q?version=1",
     *                            name: "C4R30",
     *                            description: "new desc"
     * @param config -  Configurable object for overwrite request parameters.
     */
    )
  }, {
    key: "updateDocument",
    value: (function () {
      var _updateDocument = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(projectId, payload, config) {
        var response;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/documents:rename"), payload, config);
            case 2:
              response = _context6.sent;
              return _context6.abrupt("return", response.data ? _models.EntityItem.parseV3(response.data) : null);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function updateDocument(_x19, _x20, _x21) {
        return _updateDocument.apply(this, arguments);
      }
      return updateDocument;
    }()
    /**
     * Lock documents in batch
     * https://platform.stoplight.autodesk.com/docs/docs-v1/reference/B360-Docs-V1.yaml/paths/~1projects~1%7Bproject_id%7D~1folders~1%7Bfolder_urn%7D~1documents~1reserve/post
     *
     * @param projectId - is the project id
     * @param folderUrn - is the folder urn
     * @param payload - include `lineage_urns`
     * @param config -  Configurable object for overwrite request parameters.
     */
    )
  }, {
    key: "lockDocuments",
    value: (function () {
      var _lockDocuments = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(projectId, folderUrn, payload, config) {
        var response;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.HttpService.dmV1.post("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/documents/reserve"), payload, config);
            case 2:
              response = _context7.sent;
              return _context7.abrupt("return", {
                success: (response.data.success || []).map(function (doc) {
                  return _models.EntityItem.parseV1(doc);
                }),
                fail: (response.data.failed || []).filter(function (failure) {
                  return failure.errorCode;
                })
              });
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function lockDocuments(_x22, _x23, _x24, _x25) {
        return _lockDocuments.apply(this, arguments);
      }
      return lockDocuments;
    }()
    /**
     * Unlock documents in batch
     * https://platform.stoplight.autodesk.com/docs/docs-v1/reference/B360-Docs-V1.yaml/paths/~1projects~1%7Bproject_id%7D~1folders~1%7Bfolder_urn%7D~1documents~1unreserve/post
     *
     * @param projectId - is the project id
     * @param folderUrn - is the folder urn
     * @param payload - include `lineage_urns`
     * @param config -  Configurable object for overwrite request parameters.
     */
    )
  }, {
    key: "unlockDocuments",
    value: (function () {
      var _unlockDocuments = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(projectId, folderUrn, payload, config) {
        var response;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.HttpService.dmV1.post("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/documents/unreserve"), payload, config);
            case 2:
              response = _context8.sent;
              return _context8.abrupt("return", {
                success: (response.data.success || []).map(function (doc) {
                  return _models.EntityItem.parseV1(doc);
                }),
                fail: (response.data.failed || []).filter(function (failure) {
                  return failure.errorCode;
                })
              });
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function unlockDocuments(_x26, _x27, _x28, _x29) {
        return _unlockDocuments.apply(this, arguments);
      }
      return unlockDocuments;
    }()
    /**
     * Copy documents in batch
     * https://platform.stoplight.autodesk.com/docs/docs-cp/e7ee7832f27fb-shared-batch-copy-documents-to-target-folder
     *
     * @param projectId - is the project id
     * @param options - include the target folder urn `targetFolder`
     * @param payload -, include the array of versioned urns
     * @param config -  Configurable object for overwrite request parameters.
     */
    )
  }, {
    key: "copyDocuments",
    value: (function () {
      var _copyDocuments = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(projectId, options, payload, config) {
        var query, response;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              query = _qs["default"].stringify(options, {
                addQueryPrefix: true
              });
              _context9.next = 3;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/documents:copy").concat(query), payload, config);
            case 3:
              response = _context9.sent;
              return _context9.abrupt("return", {
                success: (response.data.results || []).map(_models.EntityItem.parseV3),
                fail: response.data.errors || []
              });
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function copyDocuments(_x30, _x31, _x32, _x33) {
        return _copyDocuments.apply(this, arguments);
      }
      return copyDocuments;
    }()
    /**
     * Move documents in batch
     * https://platform.stoplight.autodesk.com/docs/docs-cp/992dac0a763f6-shared-batch-move-documents-to-target-folder
     *
     * @param projectId - is the project id
     * @param options - include the target folder urn `targetFolder`
     * @param payload -, include the array of document urns
     * @param config -  Configurable object for overwrite request parameters.
     */
    )
  }, {
    key: "moveDocuments",
    value: (function () {
      var _moveDocuments = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10(projectId, options, payload, config) {
        var query, response;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              query = _qs["default"].stringify(options, {
                addQueryPrefix: true
              });
              _context10.next = 3;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/documents:move").concat(query), payload, config);
            case 3:
              response = _context10.sent;
              return _context10.abrupt("return", {
                success: (response.data.results || []).map(_models.EntityItem.parseV3),
                fail: response.data.errors || []
              });
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function moveDocuments(_x34, _x35, _x36, _x37) {
        return _moveDocuments.apply(this, arguments);
      }
      return moveDocuments;
    }()
    /**
     * Make a previous version as the current version of one document
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F1.1/Documents%20operation%20APIs.oas2.yml?view=%2Fsingle-operation%2Fmakecurrentdocuments
     *
     * @param projectId -  is the project id
     * @param payload - include `versionedUrn`, `patchProperties`
     * @param config - configurable object for overwrite request parameters.
     */
    )
  }, {
    key: "makeCurrent",
    value: (function () {
      var _makeCurrent = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee11(projectId, payload, config) {
        var response;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/documents:make-current"), payload, config);
            case 2:
              response = _context11.sent;
              return _context11.abrupt("return", response.data ? _models.EntityItem.parseV3(response.data) : null);
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function makeCurrent(_x38, _x39, _x40) {
        return _makeCurrent.apply(this, arguments);
      }
      return makeCurrent;
    }()
    /**
     * Get the signed url to download the file
     * https://stoplight.autodesk.com/acs/bim360-docs/version%2F1.0/dm-v1.oas2.yml?view=%2Fdocument%2Fpostprojectsprojectidfoldersfolderurndocumentssignedurls
     *
     * @param projectId -  is the project id
     * @param file - shape of
     *           urn: string,
     *           name: string,
     *           contentType: one of ['application/pdf', 'application/octet-stream'],
     *           contentDisposition: one of ['inline', 'attachment']
     * @param config - configurable object for overwrite request parameters.
     * @returns the signed url
     */
    )
  }, {
    key: "getSignedUrl",
    value: (function () {
      var _getSignedUrl = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee12(projectId, file, config) {
        var payload, url, res;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              payload = {
                resources: [{
                  urn: file.urn,
                  file_name: file.name,
                  content_type: file.contentType,
                  inline: file.contentDisposition === 'inline'
                }]
              };
              url = "/projects/".concat(projectId, "/folders/").concat(file.parentFolderUrn, "/documents/signed_urls");
              _context12.next = 4;
              return this.HttpService.dmV1.post(url, payload, config);
            case 4:
              res = _context12.sent;
              return _context12.abrupt("return", Array.isArray(res.data) && res.data[0] || '');
            case 6:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getSignedUrl(_x41, _x42, _x43) {
        return _getSignedUrl.apply(this, arguments);
      }
      return getSignedUrl;
    }()
    /**
     * Get the signed cookies url to download single file
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/B360-Docs-V2.yaml/paths/~1projects~1%7BprojectId%7D~1versions~1%7BversionUrn%7D~1signed-url/get
     *
     * @param projectId -  is the project id
     * @param file - shape of
     *           urn: string,
     *           name: string,
     *           contentType: one of ['application/pdf', 'application/octet-stream'],
     *           contentDisposition: one of ['inline', 'attachment']
     * @param config - configurable object for overwrite request parameters.
     * @returns an object with the shape of url: string, status: string
     */
    )
  }, {
    key: "getOssSignedCookies",
    value: (function () {
      var _getOssSignedCookies = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee13(projectId, file, config) {
        var _res$data, _res$data2;
        var fileName, contentDisposition, options, query, fileUrn, url, res;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              fileName = file.name.replace(/'/g, '_');
              contentDisposition = "".concat(file.contentDisposition, "; filename*=utf-8''").concat(encodeURIComponent(fileName));
              options = {
                minutesExpiration: 60,
                'response-content-disposition': contentDisposition,
                'response-content-type': file.contentType
              };
              query = _qs["default"].stringify(options, {
                addQueryPrefix: true
              });
              fileUrn = encodeURIComponent(file.urn);
              url = "/projects/".concat(projectId, "/versions/").concat(fileUrn, "/signed-url").concat(query);
              _context13.next = 8;
              return this.HttpService.dmV2.get(url, (0, _extends4["default"])({}, config, {
                withCredentials: true
              }));
            case 8:
              res = _context13.sent;
              return _context13.abrupt("return", {
                url: ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.url) || '',
                status: (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.status
              });
            case 10:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function getOssSignedCookies(_x44, _x45, _x46) {
        return _getOssSignedCookies.apply(this, arguments);
      }
      return getOssSignedCookies;
    }()
    /**
     * Publish rvt files to Takeoff Models
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F3.0/ACC-Documents.oas2.yml?view=/batch-operation/post-qto-publish
     *
     * @param projectId -  the project uuid
     * @param params - shape of ["targetFolder": "publish-model-folderUrn"].
     * @param payload - shape of ["rvt-version-urn"], the limit is 200.
     * @param config -  Configurable object for overwrite request parameters.
     * @returns a promise that shape of ["results": [], "errors": []]
     */
    )
  }, {
    key: "publishTakeoffModels",
    value: (function () {
      var _publishTakeoffModels = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee14(projectId, params, payload, config) {
        var query, url, response;
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/documents/rvt/qto:publish").concat(query);
              _context14.next = 4;
              return this.HttpService.dmV3.post(url, payload, config);
            case 4:
              response = _context14.sent;
              return _context14.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function publishTakeoffModels(_x47, _x48, _x49, _x50) {
        return _publishTakeoffModels.apply(this, arguments);
      }
      return publishTakeoffModels;
    }()
    /**
     * Generate accessCode to assemble openUrl and use this value to exchange accessToken to fetch file content Will also check user permission to the entity
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F3.0/ACC-File-Content.oas2.yml?view=%2Fauthorization%2Fgenerateaccesscodes
     *
     * @param projectId -  the project uuid
     * @param id - documentId or documentUrn
     * @param payload -, request payload, empty by default
     * @param config -  Configurable object for overwrite request parameters.
     * @returns a promise with shape [authCode: string, action: one of ['edit', 'view']]
     */
    )
  }, {
    key: "getAccessCode",
    value: (function () {
      var _getAccessCode = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee15(projectId, id, payload, config) {
        var url, _yield$this$HttpServi4, _yield$this$HttpServi5, authCode, action;
        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              url = "/projects/".concat(projectId, "/documents/").concat(id, "/access-code");
              _context15.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              _yield$this$HttpServi4 = _context15.sent;
              _yield$this$HttpServi5 = _yield$this$HttpServi4.data;
              authCode = _yield$this$HttpServi5.authCode;
              action = _yield$this$HttpServi5.action;
              return _context15.abrupt("return", {
                authCode: authCode,
                action: action
              });
            case 8:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function getAccessCode(_x51, _x52, _x53, _x54) {
        return _getAccessCode.apply(this, arguments);
      }
      return getAccessCode;
    }()
    /**
     * Check whether the associated file (including the associated file’s corresponding associated file) is the last version.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/25e063e6813c8-check-linked-files
     *
     * @param projectId -  the project uuid
     * @param id - versionId or versionUrn
     * @param config -  Configurable object for overwrite request parameters.
     * @returns a promise that with status
     */
    )
  }, {
    key: "checkLinkedFilesStatus",
    value: (function () {
      var _checkLinkedFilesStatus = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee16(projectId, id, config) {
        var url, response;
        return _regenerator["default"].wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              url = "/projects/".concat(projectId, "/versions/").concat(id, "/linked-files-status");
              _context16.next = 3;
              return this.HttpService.dmV3.get(url, config);
            case 3:
              response = _context16.sent;
              return _context16.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function checkLinkedFilesStatus(_x55, _x56, _x57) {
        return _checkLinkedFilesStatus.apply(this, arguments);
      }
      return checkLinkedFilesStatus;
    }()
    /**
     * List recent 50 reviews outlines related to a specific version.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Workflows-V3.yaml/paths/~1projects~1%7Bproject_id%7D~1versions~1%7Bversion_urn%7D~1approval-status/get
     *
     * @param projectId -  the project uuid
     * @param versionUrn -version urn
     * @param params - shape of `filter[reviewStatus]`
     * @param config -  Configurable object for overwrite request parameters.
     */
    )
  }, {
    key: "getVersionApprovalStatus",
    value: (function () {
      var _getVersionApprovalStatus = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee17(projectId, versionUrn, params, config) {
        var query, url, res;
        return _regenerator["default"].wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true,
                encode: false
              });
              url = "/projects/".concat(projectId, "/versions/").concat(encodeURIComponent(versionUrn), "/approval-status").concat(query);
              _context17.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              res = _context17.sent;
              return _context17.abrupt("return", res.data || []);
            case 6:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function getVersionApprovalStatus(_x58, _x59, _x60, _x61) {
        return _getVersionApprovalStatus.apply(this, arguments);
      }
      return getVersionApprovalStatus;
    }()
    /**
     * Create a job to get files count in specified project and folders
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Documents.yaml/paths/~1projects~1%7BprojectId%7D~1documents~1count-tasks/post
     *
     * @param projectId -  the project uuid
     * @param payload - with `folderUrns`
     * @param config -  Configurable object for overwrite request parameters.
     * @returns a promise that shape of [taskId:  String]
     */
    )
  }, {
    key: "createCountTask",
    value: (function () {
      var _createCountTask = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee18(projectId, payload, config) {
        var url, response;
        return _regenerator["default"].wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              url = "/projects/".concat(projectId, "/documents/count-tasks");
              _context18.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              response = _context18.sent;
              return _context18.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function createCountTask(_x62, _x63, _x64) {
        return _createCountTask.apply(this, arguments);
      }
      return createCountTask;
    }()
    /**
     * Get the scan result by query Id.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Documents.yaml/paths/~1projects~1%7BprojectId%7D~1documents~1count-tasks~1%7BtaskId%7D/get
     *
     * @param projectId -  the project uuid
     * @param taskId - use to get the scan result with query Id.
     * @param config -  Configurable object for overwrite request parameters.
     * @returns a promise that shape of `taskId`:  String, `status`: String, `results`: [`folderUrn`,`filesCount`]
     */
    )
  }, {
    key: "getCountTask",
    value: (function () {
      var _getCountTask = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee19(projectId, taskId, config) {
        var url, response;
        return _regenerator["default"].wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              url = "/projects/".concat(projectId, "/documents/count-tasks/").concat(taskId);
              _context19.next = 3;
              return this.HttpService.dmV3.get(url, config);
            case 3:
              response = _context19.sent;
              return _context19.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function getCountTask(_x65, _x66, _x67) {
        return _getCountTask.apply(this, arguments);
      }
      return getCountTask;
    }()
    /**
     * Update document with latest references
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Documents.yaml/paths/~1projects~1%7BprojectId%7D~1documents:upgrade/post
     *
     * @param projectId -  the project uuid
     * @param payload - include versionedUrn
     * @param config -  Configurable object for overwrite request parameters.
     * @returns a promise that resolves with an object with a document
     */
    )
  }, {
    key: "upgradeDocument",
    value: (function () {
      var _upgradeDocument = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee20(projectId, payload, config) {
        var _response$data2;
        var response;
        return _regenerator["default"].wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/documents:upgrade"), payload, config);
            case 2:
              response = _context20.sent;
              if ((_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.document) {
                _context20.next = 5;
                break;
              }
              return _context20.abrupt("return", {});
            case 5:
              return _context20.abrupt("return", _models.EntityItem.parseV3(response.data.document));
            case 6:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function upgradeDocument(_x68, _x69, _x70) {
        return _upgradeDocument.apply(this, arguments);
      }
      return upgradeDocument;
    }()
    /**
     * Get file's package information
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/reference/ACC-Packages-Management.yaml/paths/~1projects~1%7BprojectId%7D~1packages-resources:batch-get-info/post
     *
     * @param projectId -  the project uuid
     * @param payload - include version ids. Max count: 200
     * @param config -  Configurable object for overwrite request parameters.
     * @returns a promise with package details
     */
    )
  }, {
    key: "getPackagesInfo",
    value: (function () {
      var _getPackagesInfo = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee21(projectId, payload, config) {
        var response;
        return _regenerator["default"].wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return this.HttpService.pkgV1.post("/projects/".concat(projectId, "/packages-resources:batch-get-info"), payload, config);
            case 2:
              response = _context21.sent;
              return _context21.abrupt("return", response.data);
            case 4:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function getPackagesInfo(_x71, _x72, _x73) {
        return _getPackagesInfo.apply(this, arguments);
      }
      return getPackagesInfo;
    }()
    /**
     * Get session status on a specific document for the current user
     * https://platform.stoplight.autodesk.com/docs/docs-cp/40800ca9e9cc9-get-a-project-version-access-status
     *
     * @param projectId -  is the project id
     * @param documentUrn - is the document urn, either lineage urn or versioned file urn
     * @param config - Configurable object for overwrite request parameters.
     * @returns an object with the shape of `isEditing: boolean`
     */
    )
  }, {
    key: "checkOfficeFileSessionStatus",
    value: (function () {
      var _checkOfficeFileSessionStatus = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee22(projectId, documentUrn, config) {
        var fileUrn, url, response;
        return _regenerator["default"].wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              fileUrn = encodeURIComponent(documentUrn);
              url = "/projects/".concat(projectId, "/versions/").concat(fileUrn, "/accessStatus");
              _context22.next = 4;
              return this.HttpService.dmV2.get(url, config);
            case 4:
              response = _context22.sent;
              return _context22.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function checkOfficeFileSessionStatus(_x74, _x75, _x76) {
        return _checkOfficeFileSessionStatus.apply(this, arguments);
      }
      return checkOfficeFileSessionStatus;
    }()
    /**
     * batch get extended-properties
     * https://platform.stoplight.autodesk.com/docs/docs-cp/307eda92fcb7f-shared-batch-get-extended-properties-by-urns
     *
     * @param projectId - the project id
     * @param payload - data: array of \{ urn: string, namespace: string \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns shape of \{ results: [\{urn, extendedProperties\}], errors: [\{urn, code, title, detail\}] \}
     */
    )
  }, {
    key: "getExtendedProperties",
    value: (function () {
      var _getExtendedProperties = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee23(projectId, payload, config) {
        var response;
        return _regenerator["default"].wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/extended-properties:batch-get"), payload, config);
            case 2:
              response = _context23.sent;
              return _context23.abrupt("return", response.data || {});
            case 4:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function getExtendedProperties(_x77, _x78, _x79) {
        return _getExtendedProperties.apply(this, arguments);
      }
      return getExtendedProperties;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Documents';
    }
  }]);
}(_base["default"]);
var _default = exports["default"] = Documents;